/* eslint-disable max-classes-per-file */
export class ResponsePresenter<T = unknown> {
  status: boolean;

  message: string;

  code: string;

  data: T;

  constructor(response: any, dataMapper: (data: any) => T) {
    this.status = response?.status || false;
    this.message = response?.message || "";
    this.code = response?.code || "";
    this.data = dataMapper(response?.data);
  }
}

export class ResponseCommonPresenter {
  status: boolean;

  message: string;

  constructor(response: any) {
    this.status = response?.status || false;
    this.message = response?.message || "";
  }
}
